import React from 'react';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './About.scss';

const START_TIME = 0;
const DURATION_TIME = 3;

const about = () => {
  let animationStarted = false;
  let days;
  let speakers;
  let presentations;
  let labs;
  let attendees;

  const startCounter = () => {
    if (!animationStarted) {
      startAnimation(days);
      startAnimation(speakers);
      startAnimation(presentations);
      startAnimation(labs);
      startAnimation(attendees);
      animationStarted = true;
    }
  };

  return (
    <>
      <div className="about-background" />
      <section className="section" id="about">
        <div className="container">
          <h1 className="about-title">ABOUT</h1>
          <div className="columns is-variable is-8 is-desktop is-multiline is-centered">
            <div className="column is-12-desktop is-12-tablet">
              <p>
                OpenSlava 2021 is the 9th edition of a successful annual IT conference focused on
                open source and emerging digital technologies, organized by Accenture in Slovakia.
              </p>
              <p className="about-emphasised">
                You should consider attending OpenSlava 2021 if you are:
              </p>
              <ul>
                <li>Technology architect or Developer</li>
                <li>IT consultant</li>
                <li>IT student and teachers from IT faculties/universities</li>
                <li>
                  IT enthusiast interested in innovations, latest trends in open source and emerging
                  digital technologies
                </li>
              </ul>
              <p>
                As we want our OpenSlava community to further grow and keep it open for everyone,
                the registration to the conference will remain free of charge.
              </p>
              <p>
                We are hosting inspirational speakers and participants from all around the globe,
                check out the full <a href="https://www.openslava.sk/2021/#/program">program</a>!
              </p>
            </div>
            {/* <div className="column is-8-desktop is-12-tablet">
              <LazyLoadTransition>
                <div className="card">
                  <iframe
                    allowFullScreen
                    frameBorder="0"
                    src="https://www.youtube.com/embed/Q42OfbMHSFM"
                    title="yt-video"
                    width="100%"
                  />
                  <footer className="footer-wrapper">
                    <strong>
                      <p className="card-footer-item">
                        Marnick Vandebroek invites you to OpenSlava 2021
                      </p>
                    </strong>
                  </footer>
                </div>
              </LazyLoadTransition>
            </div> */}
            <div className="column is-12-desktop is-12-tablet">
              <p className="about-emphasised">
                Day 1, Tuesday - October 19 TECHNOLOGY AND BUSINESS INTERSECTING
              </p>
              <ul>
                <li>Keynotes and discussions oriented towards the future</li>
              </ul>
              <p className="about-emphasised">Day 2, Wednesday - October 20 TECHNOLOGY IN FOCUS</p>
              <ul>
                <li>Lectures and presentations centered around the latest trends</li>
              </ul>
              <p className="about-emphasised">Day 3, Thursday - October 21 SPOTLIGHT ON DIGITAL</p>
              <ul>
                <li>Talks about all things online and interactive</li>
              </ul>
              <p>
                The language of the conference is English. OpenSlava ‘21 is expected to follow in
                the footsteps of the successful virtual 2020 edition and take place online.
              </p>
              <p>
                Do you want to learn more about the organizer? Visit{' '}
                <a
                  href="https://www.accenture.com/sk-sk/careers"
                  rel="noopener noreferrer"
                  target="_blank">
                  {' '}
                  www.accenture.sk
                </a>
                .
              </p>
            </div>
            {/* <div className="column is-hidden-touch is-6-desktop is-12-tablet" id="youtube-column">
              <LazyLoadTransition>
                <div className="background-layer card">
                  <div className="card-image youtube-wrapper">
                  <iframe
                    allowFullScreen
                    frameBorder="0"
                    src="https://www.youtube.com/embed/Q42OfbMHSFM"
                    title="yt-video"
                    width="100%"
                  />
                  </div>
                  <footer className="footer-wrapper">
                    <strong>
                      <p className="card-footer-item">
                        Marnick Vandebroek invites you to OpenSlava 2021
                      </p>
                    </strong>
                  </footer>
                </div>
              </LazyLoadTransition>
            </div> */}
          </div>

          <LazyLoadTransition>
            <h1 className="section-title openslava-numbers is-hidden-mobile">
              Virtual OpenSlava 2020 in numbers
            </h1>
            <Waypoint onEnter={startCounter} />
            <div className="columns is-variable is-8 is-desktop is-mobile is-multiline is-hidden-mobile">
              <div className="column is-2-desktop is-4-tablet is-offset-1-desktop single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      days = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={3}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Days</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      speakers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={25}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Speakers</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      presentations = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={13}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Presentations</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      labs = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={5}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Hands-on Labs</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      attendees = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={2700}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Unique viewers</div>
              </div>
            </div>
          </LazyLoadTransition>
        </div>
      </section>
    </>
  );
};

export default about;
